import * as React from 'react';
import Svg, { SvgProps, Path } from 'react-native-svg';

const TickIcon12 = (props: SvgProps) => (
  <Svg
    width={12}
    height={12}
    fill="none"
    {...props}
  >
    <Path
      fill={props.color ?? '#fff'}
      fillRule="evenodd"
      d="M11.035 2.474a.75.75 0 0 1-.01 1.061l-6.107 6a.75.75 0 0 1-1.05 0L.973 6.693a.75.75 0 0 1 1.052-1.07l2.367 2.326 5.581-5.484a.75.75 0 0 1 1.061.01Z"
      clipRule="evenodd"
    />
  </Svg>
);
export default TickIcon12;
